<template>
  <div class="s_footnav__holdwrap"
  @mouseenter="(e)=>{edit_show(e,true)}"
  @mouseleave="(e)=>{edit_show(e,false)}"
  :class="'s_footnav__holdwrap-' + listArr.module_style" 
  v-if="nav_list.length > 0 
  && $store.state.app.view_pattern === 'mb' 
  && $store.state.myRender.common.setting.footnavOpen
  && getCurRouter !== 'case' 
  && getCurRouter !== 'article'
  && getCurRouter !== 'help'
  && getCurRouter !== 'product'">
    <div class="hover_border_top_" v-if="$store.state.app.footnav_edit.isShow"></div>
    <div class="hover_border_left_" v-if="$store.state.app.footnav_edit.isShow"></div>
    <div class="hover_border_right_" v-if="$store.state.app.footnav_edit.isShow"></div>
    <div class="hover_border_bottom_" v-if="$store.state.app.footnav_edit.isShow"></div>
    <div class="s_footnav__wrap" 
    :class="'s_footnav__style-' + listArr.module_style + '  s_footnav__contentType-' + listArr.module_style"
    :style="listArr.module_style == 0 || listArr.module_style == 2 ? wrapBorderStyle : ''"
    >
        <template v-if="listArr.module_style == 1">
          <div class="s_footnav__whitecircle" :style="{
            backgroundColor: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.color: '',
            backgroundImage: infor.set_style.background.radio_val == 'custom' && infor.set_style.background.custom.img !== '' ? 'url('+infor.set_style.background.custom.img+')' : '',
            backgroundSize: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_size: '',
            backgroundRepeat: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_repeat: '',
            backgroundPosition: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_position: ''
          }"></div>
          <div @click="clickTopNav"
          class="s_footnav__bigicon jz_theme_bg_color" 
          :style="{backgroundColor: listArr.style_color}">
          <set_link :sendData="iconObj.intro"></set_link>
            <i class="s_footnav__bigpic"
            :class="`iconfont ${iconObj.img}`"
            :style="{
              backgroundImage: iconObj.img.indexOf('http') > -1 ? 'url('+iconObj.img+')' : ''
            }"
            ></i>
          </div>
        </template>
        <div class="s_footnav__list">
          <div class="s_footnav__item s_footnav__item-5"
          v-for="(item,index) in nav_list" :key="index"
          @click="clickNav(index)"
          :style="{
            backgroundColor: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.color: '',
            backgroundImage: infor.set_style.background.radio_val == 'custom' && infor.set_style.background.custom.img !== '' ? 'url('+infor.set_style.background.custom.img+')' : '',
            backgroundSize: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_size: '',
            backgroundRepeat: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_repeat: '',
            backgroundPosition: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_position: '',
            borderLeft: index !== 0 && infor.set_style.splitLine.radio_val == 'custom' && infor.set_style.splitLine.custom.borderWidth !== 0 ? `${infor.set_style.splitLine.custom.borderWidth}px ${infor.set_style.splitLine.custom.borderStyle} ${infor.set_style.splitLine.custom.borderColor}` : '',
            width: listArr.module_style == 1 && index == nav_list.length -1 && (nav_list.length)%2 == 0 ? 100/(nav_list.length) + '%' : iconWidth + '%',
            maxWidth: listArr.module_style == 1 && index == nav_list.length -1 && (nav_list.length)%2 == 0 ? '' : iconWidth + '%',
          }"
          >
          <div class="s_footnav__sublist" 
          :style="{
            left: firstNavWidth < 108 && index == 0 && listArr.module_style !== 3 ? 0 : '',
            right: lastNavWidth < 108 && index == nav_list.length -1 && listArr.module_style !== 3 ? 0 : '',
            top:centerIndex == index && listArr.module_style == 1 ? '-22px' : 0
          }"
          v-if="item.children.length > 0 && curIndex == index">
            <div class="s_footnav__subitem" 
              v-for="(child,i) in item.children" :key="i">{{child.name}}
              <set_link :sendData="child.intro"></set_link>
            </div>
            <i class="s_footnav__triangle"></i>
          </div>
          <set_link :sendData="item.intro" v-if="item.children.length == 0"></set_link>
            <i class="s_footnav__pic" :class="`iconfont ${item.img}`"
                v-if="(listArr.module_style == 0 && infor.set_style.content_style !== '2')
                || (listArr.module_style == 1 && infor.set_style.content_style == '1')
                || (listArr.module_style == 1 && infor.set_style.content_style == '3' && centerIndex !== index)
                || (index == 0 && listArr.module_style === 2)
                || listArr.module_style == 3"
                :style="{
                  color: item.intro.linkType == 'inside_link' && item.intro.inside_link.type == 'section'
              && item.intro.inside_link.section.value.routerPath == getCurRouter ? sePicColor : defaultPicColor,
                  backgroundImage: item.img.indexOf('http') > -1 ? 'url('+item.img+')' : ''
                }"></i>
            <div class="s_footnav__name"
              v-if="(listArr.module_style == 0 && infor.set_style.content_style !== '3')
              || (listArr.module_style == 1 && infor.set_style.content_style == '1')
              || (listArr.module_style == 1 && infor.set_style.content_style == '2' && centerIndex !== index)
              || (index !== 0 && listArr.module_style === 2)"
              :style="item.intro.linkType == 'inside_link' && item.intro.inside_link.type == 'section'
              && item.intro.inside_link.section.value.routerPath == getCurRouter ? seNameStyle : defaultNameStyle"
              >
              <template v-if="item.children.length > 0">
                <i v-if="(listArr.module_style !== 3 && listArr.module_style !== 2 && infor.set_style.content_style == '2')
                || listArr.module_style == 2
                ">≡</i>
              </template>
              <span>{{item.name}}</span>
              </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { getFshopRole } from '@/api/app';
import linkData from '@/base/linkData';

export default {
  name: "basic_footnav",
  data() {
    return {
      iconWidth: 20,
      curIndex: -1,
      centerIndex: -1,
      firstNavWidth: 0,
      lastNavWidth: 0
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    clickTopNav() {
      let arr = this.listArr.nav_list.filter(item => item.isHide == 'false')
      let len = arr.length
      if(len > 0) {
        this.clickNav(parseInt(len/2))
      }
    },
    clickNav(index) {
      let arr = this.listArr.nav_list.filter(item => item.isHide == 'false')
      let len = arr.length
      this.curIndex = this.curIndex == index ? -1 : index
      if(index == 0) {
        this.firstNavWidth = $('.s_footnav__holdwrap').find('.s_footnav__item')[0].clientWidth
      } else if(index == len-1) {
        this.lastNavWidth = $('.s_footnav__holdwrap').find('.s_footnav__item')[len-1].clientWidth
      }
    },
    getIcon(nav_list) {
      let arr = nav_list.filter(item => item.isHide == 'false')
      let len = arr.length
      if(len > 0) {
          this.iconWidth = 100/len
          if(len%2 == 0 && this.listArr.module_style == 1) {
            this.iconWidth = (100/(len + 1)).toFixed(2)
          }
      }
    },
    edit_show(e, val) {
      let that = this
      let l = $(window).width() / 2 + 375 / 2 + 10;
      let t = 4;
      if (this.listArr.module_style == 3) {
        t = 30;
        l = l - 30
      }
    if (val) {
        //门牌显示出来,此处传参要创建一个类似row的对象，保证数据统一性
        that.$store.commit("app/Reset_footnav_edit");
        that.$store.state.app.footnav_edit.isShow = true;
        that.$store.state.app.footnav_edit.left = l;
        that.$store.state.app.footnav_edit.bottom = t;
      } else {
        //门牌隐藏
        if (that.$store.state.app.footnav_edit.timer == null) {
          that.$store.state.app.footnav_edit.timer = setTimeout(() => {
            that.$store.commit("app/Reset_footnav_edit");
          }, 300);
        }
      }
    },
    async getUserLoginConfig() {
      let res = await getFshopRole();
      if (res.code === 200) {
        if (res.data) {
          let router_names = this.listArr.nav_list.map(item => { return item.router_name })          
          if(router_names.indexOf('cart') === -1){
            let linkCart = JSON.parse(JSON.stringify(linkData));
            linkCart.inside_link.section.value = {
              "id": "999",
              "link": "/cart/index",
              "name": "Inquiry Cart",
              "module": "cart:index",
              "display_name": "Inquiry Cart",
            }
            this.listArr.nav_list.push({
              "childIsShow": "false",
              "children": [],
              "img": "https://sitecdn.71360.com/static/txys-001/wm/image/member/shop.png",
              "intro": linkCart,
              "img_type": "icon",
              "isHide": "true",
              "name": "Cart",
              "router_name": "cart",
            })
          }

          if (router_names.indexOf('sign_in') === -1) {
            let loginLink = JSON.parse(JSON.stringify(linkData));
            loginLink.inside_link.section.value = {
              "id": "998",
              "link": "/user/login",
              "name": "Sign in",
              "module": "user:login",
              "display_name": "Sign in",
            }
            this.listArr.nav_list.push({
              "childIsShow": "false",
              "children": [],
              "img": "https://sitecdn.71360.com/static/txys-001/wm/image/member/user.png",
              "intro": loginLink,
              "img_type": "icon",
              "isHide": "true",
              "name": "Sign in",
              "router_name": "sign_in",
            })
          }
        }
      } else this.$message.error(res.message)
    },
  },
  watch: {
    'listArr.nav_list': {
      handler (val) {
        this.getIcon(val)
      },
      deep: true
    },
    '$store.state.myRender.common.theme_color'(val){
      let listArr = this.module.data.listArr
      if(listArr.style_color_type == 'default') {
        this.module.data.listArr.style_color = val
      }
    }
  },
  computed: {
    nav_list() {
      return this.module.data.listArr.nav_list.filter(item => item.isHide == 'false')
    },
    iconObj() {
      let list = this.module.data.listArr.nav_list.filter(item => item.isHide == 'false')
      this.centerIndex = parseInt(list.length/2)
      return list[this.centerIndex]
    },
    getCurRouter() {
      return this.$route.path.substr(1)
    },
    infor() {
      return this.module.data.mb_widgets_infor;
    },
    listArr () {
      return this.module.data.listArr;
    },
    wrapBorderStyle() {
      let infor = this.module.data.mb_widgets_infor;
      return {
        borderTop: infor.set_style.border.radio_val == 'custom' && infor.set_style.border.custom.borderWidth !== 0 ? `${infor.set_style.border.custom.borderWidth}px ${infor.set_style.border.custom.borderStyle} ${infor.set_style.border.custom.borderColor}` : ''
      }
    },
    defaultPicColor() {
        let infor = this.module.data.mb_widgets_infor;
        let listArr = this.module.data.listArr;
      return infor.default_item.icon.radio_val == 'custom' ? infor.default_item.icon.custom.color: infor.default_item.icon.radio_val == 'default' && listArr.module_style == 3 ? listArr.style_color : ''
    },
    sePicColor() {
      let infor = this.module.data.mb_widgets_infor;
      let listArr = this.module.data.listArr;
      return infor.select_item.icon.radio_val == 'default' ? listArr.style_color : infor.select_item.icon.custom.color
    },
    defaultNameStyle() {
      let infor = this.module.data.mb_widgets_infor;
      return {
        color: infor.default_item.font.radio_val == 'custom' ? infor.default_item.font.custom.color : '',
        fontFamily: infor.default_item.font.custom.fontFamily,
        fontSize: infor.default_item.font.radio_val == 'custom' ? infor.default_item.font.custom.fontSize + 'px' : '',
        fontWeight: infor.default_item.font.radio_val == 'custom' ? infor.default_item.font.custom.fontWeight : '',
        textDecoration: infor.default_item.font.radio_val == 'custom' ? infor.default_item.font.custom.textDecoration : '',
        fontStyle: infor.default_item.font.radio_val == 'custom' ? infor.default_item.font.custom.fontStyle : ''
      }
    },
    seNameStyle() {
      let infor = this.module.data.mb_widgets_infor;
      let listArr = this.module.data.listArr
      return {
        color: infor.select_item.font.radio_val == 'default' ? listArr.style_color : infor.select_item.font.custom.color,
        fontFamily: infor.select_item.font.custom.fontFamily,
        fontSize: infor.select_item.font.radio_val == 'custom' ? infor.select_item.font.custom.fontSize + 'px' : '',
        fontWeight: infor.select_item.font.radio_val == 'custom' ? infor.select_item.font.custom.fontWeight : '',
        textDecoration: infor.select_item.font.radio_val == 'custom' ? infor.select_item.font.custom.textDecoration : '',
        fontStyle: infor.select_item.font.radio_val == 'custom' ? infor.select_item.font.custom.fontStyle : ''
      }
    },
    
  },
  created() {
    this.getUserLoginConfig()
    this.getIcon(this.module.data.listArr.nav_list)
  }
};
</script>

<style scoped lang="scss">
.s_footnav__bigpic {
    color: #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-size: contain;
    font-size: 20px;
    background-repeat: no-repeat;
    background-position: 50%;
    flex-shrink: 0;
    text-align: center;
    cursor: pointer;
}
.s_footnav__whitecircle {
    width: 50px;
    height: 50px;
    top: -21px;
    box-shadow: 0 -1px 4px rgba(0,0,0,.12);
    z-index: 3001;
    background-color: #fff;
}
.s_footnav__bigicon {
    width: 42px;
    height: 42px;
    top: -17px;
    box-sizing: border-box;
    z-index: 3002;
}
.s_footnav__bigicon, .s_footnav__whitecircle {
    position: absolute;
    left: 50%;
    border-radius: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
}
.s_footnav__holdwrap {
    height: 51px;
}
.s_footnav__wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    border-top: 1px solid #ebebeb;
    transition: left,bottom .5s;
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    display: none;
    z-index: 3005;
}
.mb_pattern .s_footnav__wrap {
    display: block !important;
}
.s_footnav__sublist {
    position: absolute;
    transform: translateY(calc(-100% - 10px));
    padding: 3px 0 4px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    cursor: pointer;
    background: #fff;
    z-index: 3002;
}
.s_footnav__list {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    position: relative;
    z-index: 3001;
}
.s_footnav__subitem {
    width: 90px;
    padding: 10px 0;
    margin: 0 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
    text-decoration: none;
    border-bottom: 1px solid #ebebeb;
    color: #333;
    font-size: 13px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: relative;
}
.s_footnav__subitem:last-of-type {
    border: none;
}
.s_footnav__triangle {
    width: 0;
    height: 0;
    border: 6.8px solid transparent;
    border-top: 6.8px solid #fff;
    position: absolute;
    left: 50%;
    bottom: -13.6px;
    margin-left: -6.8px;
}
.s_footnav__triangle:before {
    content: "";
    width: 0;
    height: 0;
    border: 6.8px solid transparent;
    border-top: 6.8px solid #ebebeb;
    z-index: -1;
    position: absolute;
    left: -6.8px;
    top: -5.5px;
}
.s_footnav__item {
    color: #666;
    text-decoration: none;
    flex: 1 1;
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    padding: 3px;
    background: #fff;
    position: relative;
}
.s_footnav__item, .s_footnav__list-center {
    justify-content: center;
}
.s_footnav__pic {
    color: rgba(0, 0, 0, 0.5);
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-size: contain;
    font-size: 20px;
    background-repeat: no-repeat;
    background-position: 50%;
    flex-shrink: 0;
    text-align: center;
}
.s_footnav__name {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    font-size: 13px;
}
.s_footnav__style-1 {
    background-color: #fff;
}
.s_footnav__style-2 .s_footnav__list .s_footnav__item:first-child {
    width: 15%;
    max-width: 15%;
}
.s_footnav__style-2 .s_footnav__list .s_footnav__item:not(:first-child) {
    border-left: 1px solid #ebebeb;
}
.s_footnav__holdwrap-3 {
    height: 0 !important;
}
.s_footnav__style-3 {
    width: 80%;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    height: 40px;
    border-top: 0;
}
.s_footnav__style-3 .s_footnav__item:first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
}
.s_footnav__style-3 .s_footnav__item:last-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}
.s_footnav__style-3 .s_footnav__item {
    background: hsla(0,0%,93.3%,.9);
}
.s_footnav__style-3 .s_footnav__list .s_footnav__item:not(:first-child) {
    border-left: 1px solid hsla(0,0%,100%,.8);
}
.hover_border_top_{
  position: fixed;
  bottom: 50px;
  width: 100%;
  height: 1px;
  border-top: 1px dashed #676767;
  z-index: 5000;
}
.hover_border_bottom_{
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #676767;
  z-index: 5000;
}
.hover_border_left_{
  position: fixed;
  width: 1px;
  height: 50px;
  border-left: 1px dashed #676767;
  left: 0;
  bottom: 0;
  z-index: 5000;
}
.hover_border_right_{
  position: fixed;
  right: 0;
  bottom: 0;
  width: 1px;
  height: 50px;
  border-right: 1px dashed #676767;
  z-index: 5000;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_footnav/index.vue